import {fetchWithExceptions} from './fetch';

const VAULT_SESSION_KEY = 'vault_auth';

export function getAuth() {
  const json = window.sessionStorage.getItem(VAULT_SESSION_KEY);
  if (json != null) {
    try {
      return JSON.parse(json);
    } catch (error) {
      if (error instanceof SyntaxError) {
        window.sessionStorage.removeItem(VAULT_SESSION_KEY);
      } else {
        throw error;
      }
    }
  }
  return null;
}

export async function getOtpData(secret_id) {
  return await request('GET', `/v1/totp/keys/sylvanus-secrets-${secret_id}`);
}

export async function getSecret(secret_id) {
  return await request('GET', `/v1/secret/data/sylvanus/secrets/${secret_id}`);
}

export async function getIntegrationSecret(customer_id, name) {
  return await request('GET', `/v1/secret/data/sylvanus/integration_secrets/${customer_id}/${name}`);
}

export async function getServerSecret(server_id, name) {
  return await request('GET', `/v1/secret/data/sylvanus/server_secrets/${server_id}/${name}`);
}

export async function login(username, password) {
  storeAuth(null);
  let response = await request('POST', `/v1/auth/userpass/login/${username}`, {password});
  if ('errors' in response) {
    return response;
  }
  storeAuth(response.auth);
  return response;
}

export async function request(method, path, data = null) {
  const url = new URL(path, import.meta.env.VITE_PUBLIC_VAULT_ADDR)
  const options = {
    method: method,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  };
  if (data != null) {
    options.body = JSON.stringify(data);
  }
  const vault_auth = getAuth();
  if (vault_auth != null) {
    options.headers['X-Vault-Token'] = vault_auth.client_token;
  }
  const request = new Request(url, options);
  return await fetchWithExceptions(request);
}

export async function saveSecret(secret) {
  return await request('POST', `/v1/secret/data/sylvanus/secrets/${secret.id}`, {data: secret});
}

export async function saveIntegrationSecret(customer_id, name, value) {
  return await request('POST', `/v1/secret/data/sylvanus/integration_secrets/${customer_id}/${name}`, {data: {value: value}});
}

export async function saveServerSecret(server_id, name, value) {
  return await request('POST', `/v1/secret/data/sylvanus/server_secrets/${server_id}/${name}`, {data: {value: value}});
}

export function storeAuth(auth) {
  const storage = window.sessionStorage;
  storage.setItem(VAULT_SESSION_KEY, JSON.stringify(auth));
}
